import { useTranslation } from 'react-i18next'

export default function TrainingTrainerExtraCosts({
	extraCosts,
	disabled,
	onAdd,
	onChange,
	onRemove,
}) {
	const { t } = useTranslation()
	const items = Array.isArray(extraCosts) ? extraCosts : []

	return (
		<div className="rounded-lg border border-gray-200 p-4">
			<div className="flex items-center justify-between gap-3">
				<div>
					<h4 className="text-sm font-semibold text-gray-900">
						{t('trainings.details.trainerDialog.sections.otherExpenses')}
					</h4>
					<p className="mt-1 text-sm text-gray-500">
						{t('trainings.details.trainerDialog.otherExpensesHelp')}
					</p>
				</div>
				<button
					type="button"
					onClick={onAdd}
					disabled={disabled}
					className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
				>
					{t('trainings.details.travel.modal.actions.addCost')}
				</button>
			</div>

			<div className="mt-4 space-y-3">
				{items.length
					? items.map(item => (
						<div
							key={item._id}
							className="flex flex-col gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3"
						>
							<input
								type="text"
								value={item.tytul || ''}
								onChange={event => onChange(item._id, 'tytul', event.target.value)}
								disabled={disabled}
								placeholder={t('trainings.details.travel.modal.placeholders.costTitle')}
								className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:opacity-50"
							/>
							<input
								type="number"
								min="0"
								step="0.01"
								value={item.kwota_brutto ?? ''}
								onChange={event => onChange(item._id, 'kwota_brutto', event.target.value)}
								disabled={disabled}
								placeholder={t('trainings.details.travel.modal.placeholders.amountGross')}
								className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:opacity-50"
							/>
							<input
								type="text"
								value={item.notatka || ''}
								onChange={event => onChange(item._id, 'notatka', event.target.value)}
								disabled={disabled}
								placeholder={t('trainings.details.travel.modal.placeholders.costNote')}
								className="block w-full rounded-md bg-white px-3 py-2 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:opacity-50"
							/>
							<button
								type="button"
								onClick={() => onRemove(item._id)}
								disabled={disabled}
								className="self-start rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50"
							>
								{t('trainings.details.travel.modal.actions.removeButton')}
							</button>
						</div>
					))
					: (
						<p className="text-sm text-gray-500">{t('trainings.details.travel.modal.emptyCosts')}</p>
					)}
			</div>
		</div>
	)
}
